(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    var bars = document.querySelectorAll('[data-sticky-atc]');
    bars.forEach(function (bar) {
      var sectionId = bar.dataset.sectionId;
      var productId = bar.dataset.productId;
      var addToCartText = bar.dataset.addToCartText;
      var soldOutText = bar.dataset.soldOutText;

      var mainSectionEl = document.getElementById('ProductSection-' + sectionId + '-' + productId);
      if (!mainSectionEl) return;
      var mainAtcBtn = mainSectionEl.querySelector('[data-add-to-cart]');
      if (!mainAtcBtn) return;

      var variantsJson = bar.querySelector('[data-sticky-atc-variants]');
      var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];

      var idInput = bar.querySelector('[data-sticky-atc-id]');
      var qtyInput = bar.querySelector('[data-sticky-atc-quantity]');
      var priceEl = bar.querySelector('[data-sticky-atc-price]');
      var btn = bar.querySelector('[data-sticky-atc-btn]');
      var btnText = bar.querySelector('[data-sticky-atc-btn-text]');
      var thumbImage = bar.querySelector('[data-sticky-atc-image]');
      var qtySelect = bar.querySelector('[data-sticky-atc-qty-select]');
      var optionSelects = bar.querySelectorAll('[data-sticky-atc-option]');
      var updatingFromSticky = false;

      function updateVariantImage(variant) {
        if (!thumbImage) return;

        var defaultImage = thumbImage.dataset.stickyAtcDefaultImage;
        var variantImage = variant && variant.featured_image && variant.featured_image.src ? variant.featured_image.src : defaultImage;

        if (!variantImage) return;

        thumbImage.src = variantImage;
        thumbImage.alt = variant && variant.featured_image && variant.featured_image.alt ? variant.featured_image.alt : bar.querySelector('.sticky-atc__title').textContent.trim();
      }

      function formatMoney(cents) {
        var el = mainSectionEl.querySelector('[data-product-price]');
        if (el) {
          var s = el.textContent.trim();
          var sym = s.replace(/[\d.,\s]/g, '').trim().charAt(0) || '$';
          return sym + (cents / 100).toFixed(2);
        }
        return '$' + (cents / 100).toFixed(2);
      }

      function updateForVariant(variantId) {
        var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
        if (!variant) return;
        if (idInput) idInput.value = variant.id;
        if (priceEl) {
          var html = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += '<span class="sticky-atc__compare-price">' + formatMoney(variant.compare_at_price) + '</span>';
          }
          html += '<span class="sticky-atc__current-price">' + formatMoney(variant.price) + '</span>';
          priceEl.innerHTML = html;
        }
        if (btn && btnText) {
          if (variant.available) { btn.disabled = false; btnText.textContent = addToCartText; }
          else { btn.disabled = true; btnText.textContent = soldOutText; }
        }
        updateVariantImage(variant);
      }

      function syncOptionSelects(variantId) {
        var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
        if (!variant) return;
        optionSelects.forEach(function (sel) {
          var idx = parseInt(sel.dataset.stickyAtcOption, 10);
          if (variant.options[idx] !== undefined) sel.value = variant.options[idx];
        });
      }

      function findVariantByOptions(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      if (qtySelect && qtyInput) {
        qtySelect.addEventListener('change', function () {
          qtyInput.value = qtySelect.value;
        });
      }

      optionSelects.forEach(function (sel) {
        sel.addEventListener('change', function () {
          var opts = [];
          optionSelects.forEach(function (s) { opts.push(s.value); });
          var variant = findVariantByOptions(opts);
          if (!variant) return;
          updateForVariant(variant.id);
          var mainSelect = mainSectionEl.querySelector('select[data-product-select]');
          if (mainSelect) {
            updatingFromSticky = true;
            mainSelect.value = variant.id;
            mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
            updatingFromSticky = false;
          }
        });
      });

      var mainSelect = mainSectionEl.querySelector('select[data-product-select]');
      if (mainSelect) {
        mainSelect.addEventListener('change', function () {
          if (!updatingFromSticky) {
            updateForVariant(mainSelect.value);
            syncOptionSelects(mainSelect.value);
          }
        });
      }

      document.addEventListener('variant:changed', function (e) {
        if (!updatingFromSticky && e.detail && e.detail.sectionId === sectionId && e.detail.variant) {
          updateForVariant(e.detail.variant.id);
          syncOptionSelects(e.detail.variant.id);
        }
      });

      if (window.IntersectionObserver) {
        var observer = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          } else if (entry.boundingClientRect.top < 0) {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          } else {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          }
        }, { threshold: 0 });
        observer.observe(mainAtcBtn);
      }
    });
  }());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-button"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__variantImageSwatchScrollInit) return;
    window.__variantImageSwatchScrollInit = true;

    const updateScrollerState = (wrapper) => {
      const scroller = wrapper.querySelector('.variant-input-wrap--mobile-scroll');
      if (!scroller) return;

      if (window.matchMedia('(min-width: 769px)').matches) {
        wrapper.classList.remove('is-scrollable', 'can-scroll-left', 'can-scroll-right');
        return;
      }

      const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
      const isScrollable = maxScrollLeft > 4;
      const canScrollLeft = scroller.scrollLeft > 4;
      const canScrollRight = scroller.scrollLeft < maxScrollLeft - 4;

      wrapper.classList.toggle('is-scrollable', isScrollable);
      wrapper.classList.toggle('can-scroll-left', isScrollable && canScrollLeft);
      wrapper.classList.toggle('can-scroll-right', isScrollable && canScrollRight);
    };

    const updateScrollerButtonAlignment = (wrapper) => {
      const firstLabel = wrapper.querySelector('.variant__button-label');
      if (!firstLabel) return;

      const wrapperRect = wrapper.getBoundingClientRect();
      const labelRect = firstLabel.getBoundingClientRect();
      const buttonTop = labelRect.top - wrapperRect.top + (labelRect.height / 2);

      wrapper.style.setProperty('--scroll-button-top', `${buttonTop}px`);
    };

    const initScroller = (wrapper) => {
      if (wrapper.dataset.scrollHintReady === 'true') {
        updateScrollerButtonAlignment(wrapper);
        updateScrollerState(wrapper);
        return;
      }

      const scroller = wrapper.querySelector('.variant-input-wrap--mobile-scroll');
      const buttons = wrapper.querySelectorAll('.variant-input-scroll-button');
      if (!scroller) return;

      wrapper.dataset.scrollHintReady = 'true';
      scroller.addEventListener('scroll', () => updateScrollerState(wrapper), { passive: true });
      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const direction = button.dataset.scrollDirection === 'left' ? -1 : 1;
          scroller.scrollBy({ left: direction * 120, behavior: 'smooth' });
        });
      });
      updateScrollerButtonAlignment(wrapper);
      updateScrollerState(wrapper);
    };

    const initAllScrollers = () => {
      document.querySelectorAll('.variant-input-wrap-scroller--mobile-scroll').forEach(initScroller);
    };

    initAllScrollers();
    window.addEventListener('resize', initAllScrollers);
    document.addEventListener('shopify:section:load', initAllScrollers);
  })();
  } catch(e) { console.error(e); }
})();

})();
